import env from "../../../../env";
import React from "react";
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBRipple,
  MDBModalFooter,
} from "mdb-react-ui-kit";
import { connect } from "react-redux";
import Spinner from "../../../../components/Spinner";
import { change_user_details, notify } from "../../../../redux/actions";
import axios from "axios";
import { Collapse } from "@mui/material";
import RemoveFile from "../../../../components/RemoveFile";
import h from "../../../../utilities/helpers";
import t from "../../../../utilities/transitions";
import { motion } from "framer-motion";

const allowedExtensions = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/gif",
  "image/bmp",
  "image/webp",
  "image/svg+xml",
];

class ChangeAvatarModal extends React.Component {
  constructor(props) {
    super();
    this.state = {
      /**
       * avatar: String, Path to the user's avatar
       * avatarName: String, "Click to Change", or the name of the file the user has selected, if any
       * avatarFile: false | File object that contains an avatar file that the user selected
       * working: Boolean - Whether a new avatar is in the process of being uploaded to and processed on the server
       * newFileSelected: Boolean - Whether the current file selected is different from the user's current avatar
       */
      avatar: `${process.env.REACT_APP_BUCKET_HOST}/${env.INSTANCE_ID}/images/${props.userInfo.avatar.main}`,
      avatarName: "Click to Change",
      avatarFile: "",
      working: false,
      newFileSelected: false,
      removeConfirmOpen: false,
      removing: false,
    };
  }

  /**
   * If user's avatar changes, update the default values
   */
  componentDidUpdate(prevProps) {
    if (prevProps.userInfo.avatar.main !== this.props.userInfo.avatar.main)
      this.setState((curr) => ({
        ...curr,
        avatar: `${process.env.REACT_APP_BUCKET_HOST}/${env.INSTANCE_ID}/images/${this.props.userInfo.avatar.main}`,
        avatarName: "Click to Change",
        avatarFile: "",
      }));
  }

  getRecaptcha = () => "";
  // new Promise(async (resolve, reject) => {
  //   if (String(process.env.REACT_APP_DEV) === "true")
  //     return resolve(process.env.REACT_APP_DEV_CAPTCHA_KEY);
  //   if (this.props.captchaReady)
  //     window.grecaptcha.enterprise
  //       .execute(process.env.REACT_APP_CAPTCHA_KEY, { action: "login" })
  //       .then(resolve)
  //       .catch((err) => {
  //         console.log(err);
  //         alert("Human verification failed. Refresh the page and try again.");
  //         reject();
  //       });
  //   else
  //     setTimeout(async () => {
  //       const captchaKey = await this.getRecaptcha();
  //       resolve(captchaKey);
  //     }, 500);
  // });

  /**
   * Fired when the user clicks their avatar
   *
   * Creates a virtual file input
   * Adds a change event that sets the selected file into state
   * Appends to document body (necessary for iDevices and possibly others)
   * Clicks the input
   * Removes the input after the file is selected
   */
  selectFile = () => {
    if (String(env.UPLOADS_LOCKED) === "true")
      return alert(
        "File uploads are disabled because this free tier instance has reached or exceeded the free tier limit."
      );
    let input = document.createElement("input");
    input.type = "file";
    input.style.visibility = "hidden";
    input.style.position = "fixed";
    document.body.appendChild(input);
    input.onchange = (e) => {
      let file = e.target.files[0];
      if (allowedExtensions.indexOf(file.type) !== -1) {
        if (file.size > Number(env.MAX_INDIVIDUAL_FILE_SIZE))
          alert(
            `Max individual file size exceeded. (Max: ${Math.round(
              Number(env.MAX_INDIVIDUAL_FILE_SIZE) / (1024 * 1024)
            )}MB)`
          );
        else
          this.setState(
            (curr) => ({
              ...curr,
              avatarName: e.target.files[0].name,
              avatarFile: e.target.files[0],
              avatar: URL.createObjectURL(e.target.files[0]),
              newFileSelected: true,
            }),
            () => document.body.removeChild(input)
          );
      } else {
        document.body.removeChild(input);
        alert("Please select a valid image file (png, jpg, gif, bmp, webp)");
      }
    };
    input.click();
  };

  /**
   * Submit only if there isn't already a submission being sent
   * Set working
   * Make request to server
   * Update user details with new avatar
   * Hide modal
   */
  submit = () => {
    if (!this.state.working)
      this.setState(
        (curr) => ({
          ...curr,
          working: true,
        }),
        async () => {
          try {
            const fd = new FormData();
            const captchaKey = await this.getRecaptcha();
            fd.append("avatar", this.state.avatarFile, this.state.avatarName);
            fd.append("captchaKey", captchaKey);
            axios
              .post(
                process.env.REACT_APP_LAMBDA_DASHBOARD + "/change-avatar",
                fd
              )
              .then((res) => {
                this.props.toggleShowModal();
                this.setState(
                  (curr) => ({
                    ...curr,
                    working: false,
                    newFileSelected: false,
                  }),
                  () => {
                    this.props.change_user_details(res.data.userInfo);
                    this.props.notify(
                      <i className="fas fa-user text-success" />,
                      "Avatar Updated"
                    );
                  }
                );
              })
              .catch((err) =>
                this.setState(
                  (curr) => ({
                    ...curr,
                    working: false,
                  }),
                  () => {
                    console.log(err);
                    if (err.response?.status === 403)
                      return alert(
                        "Human verification failed. Refresh the page and try again"
                      );
                    alert("An error occurred. Please try again later");
                  }
                )
              );
          } catch (err) {
            console.log(err);
            alert("An error occurred. Please try again later.");
          }
        }
      );
  };

  toggleOpenRemoveConfirm = () =>
    this.setState((curr) => ({
      ...curr,
      removeConfirmOpen: !this.state.removeConfirmOpen,
    }));

  closeRemoveConfirm = () =>
    this.setState((curr) => ({
      ...curr,
      removeConfirmOpen: false,
    }));

  remove = () =>
    this.setState(
      (curr) => ({
        ...curr,
        removeConfirmOpen: false,
        removing: true,
      }),
      () =>
        axios
          .post(process.env.REACT_APP_LAMBDA_DASHBOARD + "/remove-own", {
            file: "avatar",
          })
          .then((res) => {
            this.props.toggleShowModal();
            this.setState(
              (curr) => ({
                ...curr,
                removing: false,
              }),
              () => {
                this.props.change_user_details({
                  ...this.props.userInfo,
                  avatar: {
                    main: "blank-avatar.png",
                    thumbnail: "blank-avatar.png",
                  },
                });
                this.props.notify(
                  <i className="far fa-times-circle text-danger" />,
                  "Avatar Removed"
                );
              }
            );
          })
          .catch((err) =>
            this.setState(
              (curr) => ({
                ...curr,
                remove: false,
              }),
              () => {
                console.log(err);
                if (err.response?.status === 403)
                  return alert(
                    "Human verification failed. Refresh the page and try again"
                  );
                alert("An error occurred. Please try again later");
              }
            )
          )
    );

  render() {
    const screenDimensions = this.props.screenDimensions;
    const canDeletePermanently =
      h.checkChadmin(this.props.userInfo) &&
      this.props.userInfo.avatar.main !== "removed.png";
    return (
      <>
        {typeof window !== "undefined" && window.navigator ? (
          <MDBModal
            id="change-avatar-modal"
            open={this.props.modalShown}
            staticBackdrop
            onClosePrevented={() => {
              if (!this.state.working) this.props.toggleShowModal();
            }}
            nClosePrevented={this.props.toggleShowModal}
            tabIndex="-1"
          >
            <MDBModalDialog
              size={
                screenDimensions.width > screenDimensions.modalBreak
                  ? "xl"
                  : "fullscreen"
              }
            >
              <MDBModalContent>
                <MDBModalHeader>
                  <MDBModalTitle>Change Avatar</MDBModalTitle>
                  <MDBBtn
                    className="btn-close"
                    color="none"
                    onClick={this.props.toggleShowModal}
                  ></MDBBtn>
                </MDBModalHeader>
                <MDBModalBody>
                  <div className="d-flex justify-content-center">
                    <MDBRipple
                      onClick={this.selectFile}
                      className="mx-auto max-w-100 cursor-pointer"
                      rippleColor="primary"
                    >
                      <p className="file-labels-dark position-absolute bottom-0 text-center w-100 mb-0 text-light cursor-pointer">
                        {this.state.avatarName}
                      </p>
                      <img
                        style={{ maxHeight: "50vh", minWidth: "10rem" }}
                        src={this.state.avatar}
                        className="max-w-100 d-block mx-auto cursor-pointer"
                      />
                    </MDBRipple>
                  </div>
                </MDBModalBody>
                {screenDimensions.width > 1200 ? (
                  <MDBModalFooter className="justify-content-between align-items-center">
                    <div className="d-flex justify-content-center align-items-center">
                      {this.props.userInfo.avatar.main !==
                        "blank-avatar.png" && (
                        <>
                          <div className="d-flex flex-column justify-content-start">
                            <MDBBtn
                              disabled={
                                this.state.removing || this.state.working
                              }
                              color="danger"
                              onClick={this.toggleOpenRemoveConfirm}
                            >
                              {this.state.removing ? (
                                <>
                                  <Spinner size="sm" className="me-2" />
                                  Removing
                                </>
                              ) : (
                                <>
                                  {this.state.removeConfirmOpen ? (
                                    "Are You Sure?"
                                  ) : (
                                    <>
                                      <i className="far fa-trash-alt me-2" />
                                      Remove Avatar
                                    </>
                                  )}
                                </>
                              )}
                            </MDBBtn>
                            <Collapse in={this.state.removeConfirmOpen}>
                              <MDBBtn
                                onClick={this.closeRemoveConfirm}
                                color="link"
                                rippleColor="primary"
                                className="d-block"
                                disabled={
                                  this.state.removing || this.state.working
                                }
                              >
                                No
                              </MDBBtn>
                              <MDBBtn
                                onClick={this.remove}
                                color="link"
                                rippleColor="primary"
                                className="d-block"
                                disabled={
                                  this.state.removing || this.state.working
                                }
                              >
                                Yes
                              </MDBBtn>
                            </Collapse>
                          </div>
                          {canDeletePermanently && (
                            <RemoveFile
                              file={`${env.INSTANCE_ID}/images/${this.props.userInfo.avatar.main}`}
                              className="ms-2"
                              callback={this.props.toggleShowModal}
                            />
                          )}
                        </>
                      )}
                    </div>

                    <div className="d-flex justify-content-end align-items-center">
                      {this.state.newFileSelected ? (
                        <>
                          {this.state.working ? (
                            <MDBBtn className="me-2" disabled color="primary">
                              <Spinner size="sm" className="me-2" />
                              Saving
                            </MDBBtn>
                          ) : (
                            <MDBBtn
                              disabled={this.state.removing}
                              onClick={this.submit}
                              color="primary"
                              className="me-2"
                            >
                              <i className="fas fa-save me-2"></i>Save
                            </MDBBtn>
                          )}
                        </>
                      ) : (
                        <></>
                      )}
                      <MDBBtn
                        className="bg-gray"
                        color="dark"
                        onClick={this.props.toggleShowModal}
                      >
                        Close
                      </MDBBtn>
                    </div>
                  </MDBModalFooter>
                ) : (
                  <MDBModalFooter
                    style={{ zIndex: 999 }}
                    className="d-flex justify-content-between align-items-start p-0"
                  >
                    {this.props.userInfo.avatar.main !== "blank-avatar.png" && (
                      <div className="d-flex w-100 m-0">
                        {this.state.removeConfirmOpen ? (
                          <motion.div
                            transition={t.transition}
                            initial={t.fade_out}
                            animate={t.normalize}
                            exit={t.fade_out}
                            className={canDeletePermanently ? "w-50" : "w-100"}
                          >
                            <p className="text-center m-0">Are you sure?</p>
                            <div className="w-100 d-flex">
                              <MDBBtn
                                className="w-50 text-primary"
                                color="link"
                                rippleColor="primary"
                                onClick={this.remove}
                              >
                                Yes
                              </MDBBtn>
                              <MDBBtn
                                className="w-50 text-primary"
                                color="link"
                                rippleColor="primary"
                                onClick={this.closeRemoveConfirm}
                              >
                                No
                              </MDBBtn>
                            </div>
                          </motion.div>
                        ) : (
                          <motion.section
                            transition={t.transition}
                            initial={t.fade_out}
                            animate={t.normalize}
                            exit={t.fade_out}
                            className={canDeletePermanently ? "w-50" : "w-100"}
                          >
                            <MDBBtn
                              disabled={
                                this.state.removing || this.state.working
                              }
                              color="danger"
                              onClick={this.toggleOpenRemoveConfirm}
                              className="modal-buttons-mobile d-block rounded-0 w-100"
                            >
                              {this.state.removing ? (
                                <>
                                  <Spinner size="sm" className="me-2" />
                                  Removing
                                </>
                              ) : (
                                <>
                                  <i className="far fa-trash-alt me-2" />
                                  Remove Avatar
                                </>
                              )}
                            </MDBBtn>
                          </motion.section>
                        )}
                        {canDeletePermanently && (
                          <RemoveFile
                            file={`${env.INSTANCE_ID}/images/${this.props.userInfo.avatar.main}`}
                            className="w-50"
                            callback={this.props.toggleShowModal}
                            mobileView={true}
                          />
                        )}
                      </div>
                    )}

                    <div className="d-flex w-100 m-0">
                      {this.state.newFileSelected && (
                        <>
                          {this.state.working ? (
                            <MDBBtn
                              className={`d-block w-50 modal-buttons-mobile rounded-0 ${
                                screenDimensions.width >
                                screenDimensions.modalBreak
                                  ? "border-bottom-left-radius-0p25rem"
                                  : ""
                              }`}
                              disabled
                              color="primary"
                            >
                              <Spinner size="sm" className="me-2" />
                              Saving
                            </MDBBtn>
                          ) : (
                            <MDBBtn
                              disabled={this.state.removing}
                              onClick={this.submit}
                              color="primary"
                              className={`d-block w-50 modal-buttons-mobile rounded-0 ${
                                screenDimensions.width >
                                screenDimensions.modalBreak
                                  ? "border-bottom-left-radius-0p25rem"
                                  : ""
                              }`}
                            >
                              <i className="fas fa-save me-2"></i>Save
                            </MDBBtn>
                          )}
                        </>
                      )}
                      <MDBBtn
                        className={`bg-gray d-block w-${
                          this.state.newFileSelected ? "50" : "100"
                        } modal-buttons-mobile rounded-0 ${
                          screenDimensions.width > screenDimensions.modalBreak
                            ? "border-bottom-right-radius-0p25rem"
                            : ""
                        } ${
                          this.state.newFileSelected
                            ? ""
                            : "border-bottom-left-radius-0p25rem"
                        }`}
                        color="dark"
                        onClick={this.props.toggleShowModal}
                      >
                        Close
                      </MDBBtn>
                    </div>
                  </MDBModalFooter>
                )}
              </MDBModalContent>
            </MDBModalDialog>
          </MDBModal>
        ) : (
          <></>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps, {
  change_user_details,
  notify,
})(ChangeAvatarModal);
